import { useTravelCalculate } from "../../../../common/api/queries";
import { CalcType } from "../../enums";
import { createCalcResultsContext } from "../contexts/calcResultsContext";
import { TravelCalc, TravelCalcResultData } from "./types";

export const { Provider: TravelCalcResultsProvider, useCalcResults: useTravelCalcResults } = createCalcResultsContext<
  TravelCalc,
  TravelCalcResultData,
  CalcType.TRAVEL
>(useTravelCalculate);
